import { render, staticRenderFns } from "./ButtonNewElement.vue?vue&type=template&id=c4fa5520&scoped=true&lang=pug&"
import script from "./ButtonNewElement.vue?vue&type=script&lang=ts&"
export * from "./ButtonNewElement.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonNewElement.vue?vue&type=style&index=0&id=c4fa5520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fa5520",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
